export const Role = {
  SuperAdmin: 1,
  Admin: 2,
  Staff: 3,
  User: 4,
};
